"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/***************************************
 * OPTION POSITIONS
 ***************************************/

/*
  react-checkbox-tree の選択肢となる option の位置情報
  選択されなかった option を除外することで template から生成した挿入する nodeMap を作成
 */

exports.DENTAL_OPTION_POSITIONS_MAP = {
  '8f58cad7-72dd-4aa9-968b-3a3aa047cd0d': [{
    nodeId: 'SKME1jqfFYts',
    optionIndex: 0
  }],
  'a20c66c5-a335-44f4-98b8-007fbe9c6d21': [{
    nodeId: 'SKME1jqfFYts',
    optionIndex: 1
  }],
  '694784cf-33ca-4de5-a135-8eed55d9680b': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 0
  }],
  '4c15cbb6-60c0-4b2f-b129-474722dbc972': [{
    nodeId: 'qMstmGJxJqYQ',
    optionIndex: 0
  }, {
    nodeId: 'UvirsytZESWo',
    optionIndex: 0
  }],
  'b8a90e9d-6625-4577-86c5-a2a47ea2a1b4': [{
    nodeId: 'qMstmGJxJqYQ',
    optionIndex: 1
  }, {
    nodeId: 'UvirsytZESWo',
    optionIndex: 1
  }],
  'f764b8f9-b170-485f-bdf3-1fcde0dd774f': [{
    nodeId: 'wXSYLLLjBy9u',
    optionIndex: 2
  }],
  'caad09fa-183a-44fd-87a6-38e62d98de1e': [{
    nodeId: 'CkMaaFobkEpY',
    optionIndex: 1
  }],
  '4d794c1e-e4a8-4d6e-ae03-ef28cf265406': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 1
  }],
  '192af280-b6e5-4183-b13f-fa6ba4bc5f09': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 2
  }],
  '53f212d5-a967-4b3f-b33c-3dc0cf2f6b9e': [{
    nodeId: 'NxOKmV4f9KOQ',
    optionIndex: 0
  }],
  '90adb1b1-06f1-42b5-9205-351408fc0299': [{
    nodeId: 'NxOKmV4f9KOQ',
    optionIndex: 1
  }],
  'b24ee4f0-14c4-4ea3-9f63-febde2f19602': [{
    nodeId: 'NxOKmV4f9KOQ',
    optionIndex: 2
  }],
  '8ebdf9db-a550-4767-ad7e-92a40cec0daf': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 3
  }],
  'f39889ad-a3a4-4c9c-b76e-abe511fb31bc': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 4
  }],
  '45f8179c-f27e-46b9-8567-4708fc247251': [{
    nodeId: '8AQtV6PgGpCN',
    optionIndex: 0
  }],
  '0dff2d5e-8cc2-4010-8236-cd9412974954': [{
    nodeId: '90JoN5wympEA',
    optionIndex: 0
  }],
  'a0a7a688-0d50-4f12-91f1-96f423c226bc': [{
    nodeId: '90JoN5wympEA',
    optionIndex: 1
  }],
  'f02aa561-57a0-4ff3-b2ba-bbc1c0abeda1': [{
    nodeId: 'rSey9bAKnJNL',
    optionIndex: 0
  }],
  'a5396074-1ada-4b10-9dd6-1f8f411b73d4': [{
    nodeId: 'd5VnVsGgleJ8',
    optionIndex: 0
  }],
  'bc298691-bc9d-4ec0-83a2-bc2687593a2d': [{
    nodeId: 'XGjcukBvhNJF',
    optionIndex: 0
  }],
  '2b495f78-4d6c-434c-bdc7-f587e700cdbe': [{
    nodeId: 'saNdiPucO7oc',
    optionIndex: 0
  }],
  '54608504-e577-435b-8049-a48a51ec6cb4': [{
    nodeId: '8AQtV6PgGpCN',
    optionIndex: 4
  }],
  '61d773cc-fddd-4ea9-98dd-44a930300419': [{
    nodeId: 'MATuTCJHnwP1',
    optionIndex: 0
  }],
  'dde6cc69-4f62-4cde-b571-99be6ee157c8': [{
    nodeId: 'MATuTCJHnwP1',
    optionIndex: 1
  }],
  'fc8658ab-a252-485b-9912-d544e931ef1e': [{
    nodeId: 'DENTAL_TEMPLATE_TOP',
    optionIndex: 5
  }],
  '4195256d-8fa0-4c85-9ece-66fa849888ee': [{
    nodeId: 'CtP9JhQ5ioox',
    optionIndex: 0
  }],
  '49680e83-059e-4c0a-aa75-508efde5a46e': [{
    nodeId: 'CtP9JhQ5ioox',
    optionIndex: 1
  }]
};
/***************************************
 * CHECK BOX TREE NODE
 ***************************************/

/*
  react-checkbox-tree に渡すためのデータ
  value には　OptionPositionsMap の id を持たせる
 */

exports.DENTAL_CHECKBOX_NODES = [{
  value: '694784cf-33ca-4de5-a135-8eed55d9680b',
  label: '虫歯治療',
  children: [// {
  //   value: '694784cf-33ca-4de5-a135-8eed55d9680b',
  //   label: '共通項目',
  // },
  {
    value: '4c15cbb6-60c0-4b2f-b129-474722dbc972',
    label: 'インレー'
  }, {
    value: 'b8a90e9d-6625-4577-86c5-a2a47ea2a1b4',
    label: 'クラウン'
  }, {
    value: 'f764b8f9-b170-485f-bdf3-1fcde0dd774f',
    label: '親知らず治療'
  }, {
    value: 'caad09fa-183a-44fd-87a6-38e62d98de1e',
    label: 'インプラント治療'
  }]
}, {
  value: '4d794c1e-e4a8-4d6e-ae03-ef28cf265406',
  label: '歯周病'
}, {
  value: '192af280-b6e5-4183-b13f-fa6ba4bc5f09',
  label: '歯の喪失',
  children: [{
    value: '53f212d5-a967-4b3f-b33c-3dc0cf2f6b9e',
    label: 'ブリッジ'
  }, {
    value: '90adb1b1-06f1-42b5-9205-351408fc0299',
    label: 'インプラント'
  }, {
    value: 'b24ee4f0-14c4-4ea3-9f63-febde2f19602',
    label: '入れ歯'
  }]
}, {
  value: '8ebdf9db-a550-4767-ad7e-92a40cec0daf',
  label: '歯のケガ'
}, {
  value: 'f39889ad-a3a4-4c9c-b76e-abe511fb31bc',
  label: '審美歯科',
  children: [// {
  //   value: 'f39889ad-a3a4-4c9c-b76e-abe511fb31bc',
  //   label: '共通項目',
  // },
  {
    value: '45f8179c-f27e-46b9-8567-4708fc247251',
    label: 'ホワイトニング',
    children: [{
      value: '0dff2d5e-8cc2-4010-8236-cd9412974954',
      label: 'ホームホワイトニング'
    }, {
      value: 'a0a7a688-0d50-4f12-91f1-96f423c226bc',
      label: 'オフィスホワイトニング'
    }]
  }, {
    value: '8f58cad7-72dd-4aa9-968b-3a3aa047cd0d',
    label: 'インレー'
  }, {
    value: 'a20c66c5-a335-44f4-98b8-007fbe9c6d21',
    label: 'クラウン'
  }, {
    value: 'f02aa561-57a0-4ff3-b2ba-bbc1c0abeda1',
    label: '矯正歯科',
    children: [{
      value: 'a5396074-1ada-4b10-9dd6-1f8f411b73d4',
      label: 'マウスピース矯正'
    }]
  }, {
    value: 'bc298691-bc9d-4ec0-83a2-bc2687593a2d',
    label: '矯正歯科',
    children: [{
      value: '2b495f78-4d6c-434c-bdc7-f587e700cdbe',
      label: 'マウスピース矯正'
    }]
  }, {
    value: '54608504-e577-435b-8049-a48a51ec6cb4',
    label: 'ホワイトニング',
    children: [{
      value: '61d773cc-fddd-4ea9-98dd-44a930300419',
      label: 'ホームホワイトニング'
    }, {
      value: 'dde6cc69-4f62-4cde-b571-99be6ee157c8',
      label: 'オフィスホワイトニング'
    }]
  }]
}, {
  value: 'fc8658ab-a252-485b-9912-d544e931ef1e',
  label: 'その他',
  children: [{
    value: '4195256d-8fa0-4c85-9ece-66fa849888ee',
    label: '口臭治療'
  }, {
    value: '49680e83-059e-4c0a-aa75-508efde5a46e',
    label: '治療後の痛み'
  }]
}];